import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyRhinoMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#d0d0d0" />
      <polygon points="120,900 240,600 540,620 680,860" fill="#8b8b8b" opacity={0.9} />
      <circle cx={360} cy={520} r={40} fill="#707070" />
      <g className="mode-copy" transform="translate(48,840)" fill="#222"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyRhinoMode;
